// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kb-0";
export var buttonContainer = "_kb-3";
export var cancelButton = "_kb-4";
export var headerSection = "_kb-6";
export var headerTitle = "_kb-9";
export var messageSideLeft = "_kb-1";
export var messageSideRight = "_kb-2";
export var orderNumberContainer = "_kb-7";
export var orderNumberLabel = "_kb-8";
export var submitButton = "_kb-5";